module.exports = __webpack_public_path__ + "img/8.ba0571f0.png";